import '../../../styles/Form.css';
import "es6-shim";
import * as React from 'react';
import { EmailCheckin, MyleInstanceClinicSettings } from '../../../dtos/KioskDtos.dtos';
import EmailValidator from '../../../services/Validator/Email/Validator';
import { IGenericsLang, ILabelSelect } from '../../../services/Language/Types';
import { FormContainerInline } from '../../FormControls/FormContainerInline';
import { SelectControl } from '../../FormControls/SelectControl';
import { InputControl } from '../../FormControls/InputControl';
import { CustomCheckbox } from '../../customFormComponents/CheckBoxGroup/Checkbox';

const Switch = require('react-switch');

interface IEmailEditProps {
    emailContactPointOptions: ILabelSelect[];
    email: EmailCheckin,
    text: IGenericsLang,
    index: number,
    focusedInputName: string,
    onEmailEdit: (email: EmailCheckin) => void,
    onDeleteEmail: () => void;
    onFocus: (pipe: (value: any) => void, value: any, mask: string, id: string) => void,
    disconnectKeyboard(): void;
    myleClinicSettings: MyleInstanceClinicSettings;
}

export const EmailEdit = (props: IEmailEditProps) => {
    const email = props.email;

    const onEmailChange = (change: (email: EmailCheckin) => void) => {
        const newEmailState = Object.assign({}, email);
        change(newEmailState);
        props.onEmailEdit(newEmailState)
    }

    const disconnectKeyboard = () => props.disconnectKeyboard();


    const contactPointTypeRender = () => (
        <SelectControl
            onChange={(contactPointType: string) => props.onEmailEdit(Object.assign({}, email, { contactPointType }))}
            placeholder={textString.labels.TypeLabel}
            value={email.contactPointType}
            options={props.emailContactPointOptions}
            onFocus={disconnectKeyboard}
        />
    )

    const emailAddressRender = () => (
        <InputControl
            placeHolder={textString.labels.EmailLabel}
            onChange={value => onEmailChange(s => s.address = value)}
            value={email.address}
            isValid={EmailValidator.validateEmail(email.address)}
            onFocus={() => props.onFocus(value => onEmailChange(s => s.address = value), email.address, "", emailId)}
            focused={props.focusedInputName === emailId}
        />
    )

    const okToContactRender = () => (
        <table style={{ width: "auto" }}>
            <tbody>
                {props.myleClinicSettings.enablePatientNotifiableContactPoints
                    ? <tr>
                        <td>
                            <CustomCheckbox 
                                label={textString.labels.NotificationsLabel}
                                checked={email.notificationsEnabled}
                                onClick={(checked) => onEmailChange(email => email.notificationsEnabled = checked)}
                            />
                        </td>
                    </tr>
                    : <tr>
                        <td><span className="input-label">{textString.labels.OkToContactLabel}</span></td>
                        <td style={{ paddingLeft: "30px" }}>
                            <Switch
                                onChange={(value: boolean) => onEmailChange(s => s.isOkToContact = value)}
                                checked={email.isOkToContact}
                                height={40}
                                width={80}
                                handleDiameter={30}
                                offColor="#ef6e64"
                                onColor="#4bca81"
                                uncheckedIcon={false}
                                checkedIcon={false}
                                aria-labelledby="neat-label"
                            />
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    )

    const textString = props.text;
    const emailId = "emailEdit" + props.index;
    return (
        <div className="col-sm-12">
            <FormContainerInline
                onDelete={props.onDeleteEmail}
                elements={[
                    contactPointTypeRender(),
                    emailAddressRender(),
                    okToContactRender()
                ]}
            />
        </div>
    );
}




// WEBPACK FOOTER //
// ./src/components/PatientOverview/EditComponents/EmailEdit.tsx